import { useEffect, useState } from 'react'
import { useErrorHandling } from '@/tools/o11y/client'

export const useIntersectionDetection = (elementId1: string, elementId2: string) => {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const { execWithErrorTracking } = useErrorHandling()

  useEffect(() => {
    execWithErrorTracking(async () => {
      if (typeof window !== 'undefined') {
        let hasIntersected = false
        let lastScrollY = window.scrollY

        const checkIntersection = () => {
          const element1 = document.getElementById(elementId1)
          const element2 = document.getElementById(elementId2)

          if (element1 && element2) {
            const position1 = element1.getBoundingClientRect()
            const position2 = element2.getBoundingClientRect()

            const isIntersecting =
              position1.top < position2.bottom && position1.bottom > position2.top

            const currentScrollY = window.scrollY

            const isScrollingUp = currentScrollY < lastScrollY

            if (isIntersecting && !hasIntersected) {
              setIsIntersecting(true)
              hasIntersected = true
            }
            if (isScrollingUp && hasIntersected && isIntersecting) {
              setIsIntersecting(false)
              hasIntersected = false
            }

            lastScrollY = currentScrollY
          }
        }

        checkIntersection()
        window.addEventListener('scroll', checkIntersection)

        return () => {
          window.removeEventListener('scroll', checkIntersection)
        }
      }
    })
  }, [elementId1, elementId2, execWithErrorTracking])
  return isIntersecting
}
